import script from "./MenuParceriaView.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuParceriaView.vue?vue&type=script&setup=true&lang=js"

import "./MenuParceriaView.vue?vue&type=style&index=0&id=500a2b16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-500a2b16"]])

export default __exports__